const situacoesSolicitacao = {
  "AGUARDANDO_ANALISE": "Aguardando Análise",
  "EM_ANALISE": "Em Análise",
  "EM_ANALISE_ASSESSORIA": "Em Análise (Assessoria)",
  "DOCUMENTACAO_PENDENTE": "Documentação Pendente",
  "AUTORIZADO": "Autorizado",
  "NAO_AUTORIZADO": "Não Autorizado",
  "CANCELADO": "Cancelado",
  "PRE_AUTORIZADO": "Pré-Autorizado"
  
}


export default situacoesSolicitacao;